import * as types from "../types/packmate.work.types";

const initialState = {
  workData: [],
  workPagination: {},
  workDetailData: [],
  approvalHistoryData: [],
  approvalHistoryPagination: {},
};

const WorkReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_WORK_DATA:
      return { ...state, workData: action.payload };
    case types.SET_WORK_PAGINATION:
      return { ...state, workPagination: action.payload };
    case types.SET_WORK_DETAIL_DATA:
      return { ...state, workDetailData: action.payload };
    case types.SET_APPROVAL_HISTORY_DATA:
      return { ...state, approvalHistoryData: action.payload };
    case types.SET_APPROVAL_HISTORY_PAGINATION:
      return { ...state, approvalHistoryPagination: action.payload };
    default:
      return state;
  }
};
export default WorkReducer;
